import React, { useState } from "react";

const LoadingImage = ({ src, srcSet, sizes, alt, className, onClick }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const handleLoad = () => setIsLoaded(true);
  return (
    <div className={`relative ${className}`} onClick={onClick}>
      {!isLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 rounded-3xl animate-pulse">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide-icon animate-spin text-gray-500"
          >
            <line x1="12" x2="12" y1="2" y2="6"></line>
            <line x1="12" x2="12" y1="18" y2="22"></line>
            <line x1="4.93" x2="7.76" y1="4.93" y2="7.76"></line>
            <line x1="16.24" x2="19.07" y1="16.24" y2="19.07"></line>
            <line x1="2" x2="6" y1="12" y2="12"></line>
            <line x1="18" x2="22" y1="12" y2="12"></line>
            <line x1="4.93" x2="7.76" y1="19.07" y2="16.24"></line>
            <line x1="16.24" x2="19.07" y1="7.76" y2="4.93"></line>
          </svg>
        </div>
      )}
      <img
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        onLoad={handleLoad}
        loading="lazy"
        className={`w-full h-full object-cover object-center transition-opacity duration-300 ${
          isLoaded ? "opacity-100" : "opacity-0"
        }`}
      />
    </div>
  );
};

export default LoadingImage;
